export default __webpack_public_path__ + "static/logo_sponsors_vignette-aecb69aeb7ff57e5d41a06c80c7520e6.png";